module.exports = [{
      plugin: require('../node_modules/gatsby-omni-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"enableListener":true,"preconnect":["https://fonts.googleapis.com","https://fonts.gstatic.com","https://use.typekit.net"],"web":[{"name":"Barlow","file":"https://fonts.googleapis.com/css2?family=Barlow:wght@400;600&display=swap"},{"name":"IvyPresto Headline","file":"https://use.typekit.net/sjk0pgq.css"}]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
